import * as React from "react";
import { Progress } from "@/components/ui/progress";

interface LoadingComponentProps {
  /** Update interval in milliseconds */
  updateInterval?: number;
  /** Increment step for progress (0-100) */
  incrementStep?: number;
}

export function LoadingComponent({ updateInterval = 500, incrementStep = 10 }: LoadingComponentProps) {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {
        const nextValue = prev + incrementStep;
        return nextValue > 93 ? 97 : nextValue;
      });
    }, updateInterval);

    return () => clearInterval(timer);
  }, [updateInterval, incrementStep]);

  return (
    <div className="flex h-full min-h-[89vh] w-full items-center justify-center">
      <Progress value={progress} className="w-[60%]" />
    </div>
  );
}
